export default class LocalStorage {

    static get(id: string): any | null {
        if (!window.localStorage) return undefined;
        // Look in local storage for object
        let key = this._getClassTypeName(id);
        let str = window.localStorage.getItem(key);
        if (str != null) {
            try {
                let object = JSON.parse(str);
                return object;
            } catch(e) {
                return null;
            }
        }

        return str;
    }

    static set(key: string, value: any) {
        if (!window.localStorage) return undefined;
        window.localStorage.setItem(key, JSON.stringify(value));
    }

    static remove(key: string) {
        if (!window.localStorage) return undefined;
        window.localStorage.removeItem(key);
    }

    static delete(key: string) {
        this.remove(key);
    }

    // Todo: for more complicated objects.
    private static _getClassTypeName<T>(id: string): string {
        return id;
    }

}
